import { useEffect, useState } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电视剧分类", to: "/category" },
  { label: "影视资讯", to: "/news" },
  { label: "关于我们", to: "/about" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const submitSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : "/search");
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="w-full px-4 md:px-6">
        <div className="flex h-16 items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2 shrink-0" aria-label="善良的秘书 首页">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
              <i className="ri-book-marked-line text-xl"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-heading text-base font-bold tracking-wide text-foreground-950">
                善良的秘书
              </span>
              <span className="mt-0.5 font-label text-[10px] uppercase tracking-[0.2em] text-foreground-500">
                Drama Archive
              </span>
            </span>
          </Link>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors ${
                    isActive
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-700 hover:text-primary-600 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <form
              onSubmit={submitSearch}
              className="hidden lg:flex items-center gap-2 rounded-full border border-background-200 bg-background-100 pl-3 pr-1 py-1"
            >
              <i className="ri-search-line text-base text-foreground-500"></i>
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧名、演员"
                aria-label="搜索剧名或演员"
                className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
              />
              <button
                type="submit"
                className="rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50 whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
              >
                搜索
              </button>
            </form>

            <Link
              to="/search"
              className="lg:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:text-primary-600 transition-colors"
              aria-label="搜索"
            >
              <i className="ri-search-line text-xl"></i>
            </Link>

            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="md:hidden flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 cursor-pointer"
              aria-label="打开菜单"
              aria-expanded={open}
            >
              <i className={`text-xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="md:hidden border-t border-background-200 bg-background-50 animate-soft-fade">
          <div className="px-4 py-4 space-y-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `block rounded-md px-4 py-3 text-sm font-medium ${
                    isActive ? "bg-primary-50 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <form onSubmit={submitSearch} className="flex items-center gap-2 pt-2">
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧名、演员"
                aria-label="搜索剧名或演员"
                className="flex-1 rounded-md border border-background-200 bg-background-100 px-3 py-2.5 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300"
              />
              <button
                type="submit"
                className="rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 whitespace-nowrap cursor-pointer"
              >
                搜索
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}